<template>
    <div class="classList">
        <div class="top-search">
            <el-form
                    :model="SearchFormModel"
                    :rules="SearchFormRules"
                    ref="SearchFormRef"
                    size="small"
            >
                <form-com
                        :FormField="SearchFormField"
                        :FormModel="SearchFormModel"
                        :formLabelWidth="SearchFormLabelWidth"
                        :key="timer"
                ></form-com>
                <el-form-item>
                    <el-button
                            type="success"
                            @click="submitForm"
                    >搜索
                    </el-button>
                    <el-button @click="resetForm('SearchFormRef')">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="tab-box">
            <!-- list table -->
            <el-table
                    ref="multipleTable"
                    :data="tableData"
                    border
                    tooltip-effect="dark"
                    style="width: 100%"
                    class="bg-header td-table"
                    size="small"
            >
                <!-- 列表 -->
                <el-table-column
                        v-for="(item, index) in tableField"
                        :key="index"
                        :prop="item.prop"
                        :label="item.label"
                        :align="item.align"
                        :width="item.width"
                        show-overflow-tooltip
                >
                </el-table-column>
            </el-table>
            <div class="page-block">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="this.limit"
                        layout="sizes, prev, pager, next, jumper"
                        :total="totalCount"
                >
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        contestRank,
        newStudents,
        getContestOption
    } from "@/api/parent";
    import {
        ParentSearchRace_field,
        ParentAddStudent_field,
    } from "@/config/FormField";
    import Lockr from "lockr";
    import {getFormData, getSelectData} from "@/utils/form";
    import FormCom from "@/components/Element/FormCom";
    import DialogForm from "@/components/Element/DialogForm/index";

    export default {
        name: "studentList",
        components: {
            FormCom
        },
        data() {
            return {
                // 筛选
                timer: "",
                SearchFormModel: {},
                SearchFormField: ParentSearchRace_field,
                SearchFormRules: {},
                SearchFormLabelWidth: "",
                // 列表
                tableField: [
                    {
                        prop: "realname",
                        label: "学员姓名",
                        align: "center"
                    },
                    {
                        prop: "emp_no",
                        label: "学员账号",
                        align: "center"
                    },
                    {
                        prop: "edition_name",
                        label: "竞赛类型",
                        align: "center"
                    },
                    {
                        prop: "total_num",
                        label: "测试数量",
                        align: "center"
                    },
                    {
                        prop: "create_time",
                        label: "测试时间",
                        width: "120px",
                        align: "center"
                    },
                    {
                        prop: "use_time",
                        label: "完成时间",
                        width: "120px",
                        align: "center"
                    },
                    {
                        prop: "test_time",
                        label: "标准时间",
                        width: "120px",
                        align: "center"
                    },
                    {
                        prop: "isPass",
                        label: "是否通过",
                        width: "120px",
                        align: "center"
                    },
                ],
                raceArr: [],
                page: 1,
                limit: 10,
                tableData: [],
                currentPage: 1,
                totalCount: 0,
                // 导入
                classId: this.$route.query.class_id
            };
        },
        methods: {
            // 重置搜索
            resetForm(formName) {
                this.queryResult = {};
                this.$refs[formName].resetFields();
                this.refreshTable();
            },
            // 搜索
            submitForm(formName) {
                // this.classId = this.SearchFormModel.class_id
                this.refreshTable()
            },
            //获取竞赛类型
            getRaceType() {
                let parms = {
                    token: Lockr.get('token')
                }
                let arrOption = []

                getContestOption(parms).then(result => {
                    arrOption = getSelectData(result.data, "name", "id");
                    let val=ParentSearchRace_field
                    console.log(ParentSearchRace_field,'哈哈哈哈哈哈');
                    val[0].setting = arrOption

                    let res = getFormData(val);
                    this.SearchFormModel = res.model;
                    this.SearchFormRules = res.rules;
                })
                console.log(this.raceArr, '数组');
            },
            // 学生列表
            async tableList() {
                let params = {
                    ...this.SearchFormModel,
                    token: Lockr.get("parentToken"),
                    page: this.page,
                    limit: this.limit
                }
                let result = await contestRank(params);
                if (result.code === this.GLOBAL.Serve.SUCCESS_CODE) {
                    this.tableData = result.data.dataList || [];
                    this.tableData.map(item => {
                        if (item.is_pass == 1) {
                            item.isPass = '通过'
                        } else {
                            item.isPass = '不通过'
                        }
                    })
                    this.totalCount = result.data.count || 0;
                    this.currentPage = this.page;
                } else {
                    this.$message({
                        message: result.msg,
                        type: "warning"
                    });
                }
            },
            refreshTable() {
                this.page = 1;
                this.tableList();
            },
            handleSizeChange(value) {
                this.limit = value;
                this.tableList();
            },
            handleCurrentChange(value) {
                this.page = value;
                this.tableList();
            },
        },
        created() {

            this.tableList();
            this.getRaceType()
        },
        beforeCreate() {
            document
                .querySelector("body")
                .setAttribute("style", "background-color:#fff");
        }
    };
</script>

<style scoped lang='less'>
    @import "../../assets/css/form";

    .tab-box {
        background: #fff;
        padding: 16px;

        .el-button--text {
            font-weight: bold;
        }

        .el-button--text:nth-of-type(1) {
            color: #fb8048;
        }

        .tab-title-btn {
            padding: 15px 20px;
            background: #f7f4f8;
            display: flex;
            justify-content: space-between;
            align-items: center;

            > div:nth-of-type(2) {
                color: #416489;
                cursor: pointer;
            }

            > div:nth-of-type(2):hover {
                color: #2c7d89;
            }
        }

        .el-table {
            font-size: 14px;
            margin-top: 20px;
        }

        .page-block {
            padding-top: 15px;
        }
    }

    .dislog-box {
        padding: 20px 20%;
        background: #fff;

        .dialog-footer {
            text-align: center;
        }

        .select-course {
            border: 1px solid #dcdcdc;
            height: 38px;
            padding-left: 15px;
            transition: all 0.5s;
            border-radius: 3px;
            cursor: pointer;

            img {
                width: 13px;
                height: 13px;
                float: right;
                margin-top: 10px;
                margin-right: 10px;
            }
        }

        .select-course:hover {
            border: 1px solid #409eff;
        }
    }

    .delsuccess-box {
        > div:nth-of-type(1) {
            display: flex;
            justify-content: center;
        }

        .delsuccess-btn {
            display: flex;
            align-items: center;
            flex-direction: column;
            font-size: 24px;

            > div {
                margin-top: 20px;
            }
        }
    }
</style>

<!--<template>-->
<!--    <div class="classList">-->
<!--        <el-form :model="searchForm">-->
<!--            <div class="top-search">-->
<!--                <div class="search-item">-->
<!--                    <div>竞赛类型</div>-->
<!--                    <el-input v-model="searchForm.class1" placeholder="请输入内容"></el-input>-->
<!--                </div>-->
<!--                <div class="search-item">-->
<!--                    <div>测试数量</div>-->
<!--                    <el-select v-model="searchForm.region" placeholder="请选择">-->
<!--                        <el-option label="100" value="shanghai"></el-option>-->
<!--                        <el-option label="200" value="beijing"></el-option>-->
<!--                    </el-select>-->
<!--                </div>-->
<!--                <div class="search-item">-->
<!--                    <div>学员名称</div>-->
<!--                    <el-input v-model="searchForm.class2" placeholder="请输入内容"></el-input>-->
<!--                </div>-->
<!--                <div class="search-btn">-->
<!--                    <el-button type="primary">搜 索</el-button>-->
<!--                    <el-button>重 置</el-button>-->
<!--                </div>-->
<!--            </div>-->
<!--        </el-form>-->
<!--        <div class="tab-box">-->
<!--            <div class="tab-title-btn">-->
<!--                <el-button @click="open()" type="danger">解绑学员</el-button>-->
<!--            </div>-->
<!--            <el-table-->
<!--                    ref="multipleTable"-->
<!--                    :data="tableData"-->
<!--                    tooltip-effect="dark"-->
<!--                    style="width: 100%"-->
<!--            >-->
<!--                <el-table-column-->
<!--                        type="selection"-->
<!--                        width="55">-->
<!--                </el-table-column>-->
<!--                <el-table-column-->
<!--                        label="学员姓名"-->
<!--                >-->
<!--                    <template slot-scope="scope">{{ scope.row.name }}</template>-->
<!--                </el-table-column>-->
<!--                <el-table-column-->
<!--                        prop="id"-->
<!--                        label="学员账号"-->
<!--                        width="250"-->
<!--                >-->
<!--                </el-table-column>-->
<!--                <el-table-column-->
<!--                        prop="type"-->
<!--                        label="竞赛类型"-->
<!--                        show-overflow-tooltip>-->
<!--                </el-table-column>-->
<!--                <el-table-column-->
<!--                        prop="num"-->
<!--                        label="测试数量"-->
<!--                        show-overflow-tooltip>-->
<!--                </el-table-column>-->
<!--                <el-table-column-->
<!--                        prop="testDate"-->
<!--                        label="测试时间"-->
<!--                        show-overflow-tooltip>-->
<!--                </el-table-column>-->
<!--                <el-table-column-->
<!--                        prop="successDate"-->
<!--                        label="完成时间"-->
<!--                        show-overflow-tooltip>-->
<!--                </el-table-column>-->
<!--                <el-table-column-->
<!--                        prop="standardDate"-->
<!--                        label="标准时间"-->
<!--                        show-overflow-tooltip>-->
<!--                </el-table-column>-->
<!--                <el-table-column-->
<!--                        label="是否通过"-->
<!--                        width="200">-->
<!--                    <template slot-scope="scope">-->
<!--                        <div class="tab-icon" v-if="scope.row.isSuccess=='已通过'">-->
<!--                        <img src="../../assets/img/parents/success.png" alt="">-->
<!--                        <span>{{scope.row.isSuccess}}</span>-->
<!--                    </div>-->
<!--                        <div class="tab-icon" v-else>-->
<!--                            <img src="../../assets/img/parents/aborted.png" alt="">-->
<!--                            <span>{{scope.row.isSuccess}}</span>-->
<!--                        </div>-->

<!--                    </template>-->
<!--                </el-table-column>-->
<!--            </el-table>-->
<!--            <div class="page-block">-->
<!--                <el-pagination-->
<!--                        @size-change="handleSizeChange"-->
<!--                        @current-change="handleCurrentChange"-->
<!--                        :current-page="currentPage"-->
<!--                        :page-sizes="[100, 200, 300, 400]"-->
<!--                        :page-size="100"-->
<!--                        layout="total, sizes, prev, pager, next, jumper"-->
<!--                        :total="400">-->
<!--                </el-pagination>-->
<!--            </div>-->
<!--        </div>-->
<!--    </div>-->
<!--</template>-->

<!--<script>-->
<!--    export default {-->
<!--        name: "untieStudent",-->
<!--        data() {-->
<!--            return {-->
<!--                searchForm: {-->
<!--                    name: '',-->
<!--                    class1: '',-->
<!--                    class2: '',-->
<!--                },-->
<!--                formLabelWidth: '120px',-->
<!--                tableData: [{-->
<!--                    name: '王小虎',-->
<!--                    id: '2016934023545034',-->
<!--                    type: '小学低年级',-->
<!--                    num: '100',-->
<!--                    testDate: '2019-2-18',-->
<!--                    successDate: '190秒',-->
<!--                    standardDate: '200秒',-->
<!--                    isSuccess: '已通过'-->
<!--                }, {-->
<!--                    name: '王小虎',-->
<!--                    id: '2016934023545034',-->
<!--                    type: '小学低年级',-->
<!--                    num: '100',-->
<!--                    testDate: '2019-2-18',-->
<!--                    successDate: '190秒',-->
<!--                    standardDate: '200秒',-->
<!--                    isSuccess: '已通过'-->
<!--                }, {-->
<!--                    name: '王小虎',-->
<!--                    id: '2016934023545034',-->
<!--                    type: '小学低年级',-->
<!--                    num: '100',-->
<!--                    testDate: '2019-2-18',-->
<!--                    successDate: '190秒',-->
<!--                    standardDate: '200秒',-->
<!--                    isSuccess: '未通过'-->
<!--                }, {-->
<!--                    name: '王小虎',-->
<!--                    id: '2016934023545034',-->
<!--                    type: '小学低年级',-->
<!--                    num: '100',-->
<!--                    testDate: '2019-2-18',-->
<!--                    successDate: '190秒',-->
<!--                    standardDate: '200秒',-->
<!--                    isSuccess: '未通过'-->
<!--                }, {-->
<!--                    name: '王小虎',-->
<!--                    id: '2016934023545034',-->
<!--                    type: '小学低年级',-->
<!--                    num: '100',-->
<!--                    testDate: '2019-2-18',-->
<!--                    successDate: '190秒',-->
<!--                    standardDate: '200秒',-->
<!--                    isSuccess: '已通过'-->
<!--                }, {-->
<!--                    name: '王小虎',-->
<!--                    id: '2016934023545034',-->
<!--                    type: '小学低年级',-->
<!--                    num: '100',-->
<!--                    testDate: '2019-2-18',-->
<!--                    successDate: '190秒',-->
<!--                    standardDate: '200秒',-->
<!--                    isSuccess: '已通过'-->
<!--                },-->
<!--                ],-->
<!--                currentPage: 5,-->

<!--                addDialog: false,-->
<!--                addForm: {-->
<!--                    name: '',-->

<!--                },-->
<!--            };-->
<!--        },-->
<!--        methods: {-->
<!--            open() {-->
<!--                this.$confirm('此操作将解绑此学员, 是否继续?', '提示', {-->
<!--                    confirmButtonText: '确定',-->
<!--                    cancelButtonText: '取消',-->
<!--                    type: 'warning'-->
<!--                }).then(() => {-->
<!--                    this.$message({-->
<!--                        type: 'success',-->
<!--                        message: '删除成功!'-->
<!--                    });-->
<!--                }).catch(() => {-->
<!--                    this.$message({-->
<!--                        type: 'info',-->
<!--                        message: '已取消删除'-->
<!--                    });-->
<!--                });-->
<!--            },-->
<!--            handleSizeChange() {-->
<!--            },-->
<!--            handleCurrentChange() {-->
<!--            }-->
<!--        },-->
<!--        created() {-->
<!--            // 实例创建完成-->
<!--            // this.infoData();-->
<!--        }-->
<!--        ,-->
<!--        beforeCreate() {-->
<!--            document.querySelector("body").setAttribute("style", "background-color:#fff");-->
<!--        }-->
<!--    }-->
<!--</script>-->

<!--<style scoped lang='less'>-->
<!--    .top-search {-->
<!--        background: #fff;-->
<!--        padding: 20px 15px;-->
<!--        display: flex;-->
<!--        align-items: flex-end;-->

<!--        .search-item {-->
<!--            width: 160px;-->
<!--            margin-right: 35px;-->

<!--            > div:nth-of-type(1) {-->
<!--                margin: 10px 0;-->
<!--                font-size: 18px;-->
<!--            }-->
<!--        }-->

<!--        .search-btn {-->
<!--            display: flex;-->
<!--            justify-content: space-between;-->
<!--            width: 180px;-->
<!--        }-->
<!--    }-->

<!--    .tab-box {-->
<!--        background: #fff;-->
<!--        padding: 16px;-->

<!--        .tab-title-btn {-->
<!--            padding: 15px 20px;-->
<!--            background: #f7f4f8;-->
<!--        }-->

<!--        .el-table {-->
<!--            font-size: 18px;-->
<!--        }-->

<!--        .page-block {-->
<!--            padding-top: 15px;-->
<!--        }-->
<!--    }-->

<!--    .dislog-box {-->
<!--        padding: 20px 20%;-->
<!--        background: #fff;-->

<!--        .dialog-footer {-->
<!--            text-align: center;-->
<!--        }-->
<!--    }-->

<!--    .tab-icon {-->
<!--        display: flex;-->
<!--        align-items: center;-->

<!--        > img {-->
<!--            width: 30px;-->
<!--            height: 30px;-->
<!--            margin-right: 5px;-->
<!--        }-->
<!--    }-->
<!--</style>-->